import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { LuPlus, LuTrash2 } from 'react-icons/lu';
import api from '../../../services/api';

// Tarifa por volumen del cliente (MO por equipo, sin IVA). Se cambia poco: va en una línea
// ("$33.000 hasta 59 · $30.000 · $28.000") y se abre con "Editar" (14-oct-2026).
const INPUT = 'h-9 px-2 rounded-lg text-body font-bold outline-none bg-card text-ink border border-black/[0.05] dark:border-white/[0.05] w-full';
const pesos = v => `$${Math.round(Number(v || 0)).toLocaleString('es-AR')}`;

export function resumenTarifa(tramos) {
    if (!tramos?.length) return 'Sin tarifa cargada';
    return tramos.map((t, i) => {
        const sig = tramos[i + 1];
        const rango = sig ? `${t.desde}–${sig.desde - 1}` : `${t.desde}+`;
        return `${rango}: ${pesos(t.precio)}`;
    }).join(' · ');
}

export default function TarifaTramos({ clienteId, onGuardada }) {
    const [tramos, setTramos] = useState(null);
    const [guardados, setGuardados] = useState([]);
    const [editando, setEditando] = useState(false);
    const [guardando, setGuardando] = useState(false);
    const leer = (d) => (d || []).map(t => ({ desde: String(t.desde), precio: String(Math.round(Number(t.precio))) }));

    useEffect(() => {
        api.get(`/clientes/${clienteId}/tarifa-volumen`)
            .then(r => { const t = leer(r.data); setTramos(t); setGuardados(t); if (!t.length) setEditando(true); })
            .catch(() => { setTramos([]); toast.error('No se pudo leer la tarifa del cliente'); });
    }, [clienteId]);

    const cambiar = (i, campo, valor) => setTramos(ts => ts.map((t, k) => (k === i ? { ...t, [campo]: valor.replace(/[^0-9]/g, '') } : t)));
    const guardar = async () => {
        const payload = tramos.filter(t => t.desde !== '' && t.precio !== '').map(t => ({ desde: Number(t.desde), precio: Number(t.precio) }));
        if (payload.length && !payload.some(t => t.desde === 0)) { toast.error('El primer tramo tiene que arrancar en 0 equipos'); return; }
        setGuardando(true);
        try {
            const r = await api.put(`/clientes/${clienteId}/tarifa-volumen`, payload);
            setTramos(leer(r.data));
            setGuardados(leer(r.data));
            setEditando(false);
            toast.success('Tarifa guardada');
            onGuardada && onGuardada();
        } catch { toast.error('No se pudo guardar la tarifa'); }
        finally { setGuardando(false); }
    };

    if (tramos === null) return null;
    if (!editando) {
        return (
            <div className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-panel">
                <div className="flex-1 min-w-0">
                    <p className="text-label font-black text-muted uppercase tracking-widest">Tarifa por equipo (sin IVA)</p>
                    <p className="text-caption text-secondary">{resumenTarifa(tramos.map(t => ({ desde: Number(t.desde), precio: Number(t.precio) })))}</p>
                </div>
                <button type="button" onClick={() => setEditando(true)} className="h-8 px-3 shrink-0 rounded-lg bg-chip text-label font-black text-ink active:scale-95">Editar</button>
            </div>
        );
    }
    return (
        <div className="p-3 rounded-xl bg-panel space-y-1.5">
            <p className="text-label font-black text-muted uppercase tracking-widest">Tarifa por equipo (sin IVA)</p>
            {tramos.map((t, i) => (
                <div key={i} className="flex items-center gap-1.5">
                    <span className="text-caption text-muted shrink-0 w-11">Desde</span>
                    <input inputMode="numeric" value={t.desde} onChange={e => cambiar(i, 'desde', e.target.value)} aria-label="Desde cuántos equipos" className={INPUT + ' !w-14 text-center'} placeholder="0" />
                    <span className="text-caption text-muted shrink-0">eq. → $</span>
                    <input inputMode="numeric" value={t.precio} onChange={e => cambiar(i, 'precio', e.target.value)} aria-label="Precio por equipo" className={INPUT} placeholder="33000" />
                    <button type="button" onClick={() => setTramos(ts => ts.filter((_, k) => k !== i))} aria-label="Sacar tramo" className="w-9 h-9 shrink-0 rounded-lg flex items-center justify-center text-muted bg-chip active:scale-95"><LuTrash2 size={14} /></button>
                </div>
            ))}
            {!tramos.length && <p className="text-caption text-muted">Sin tarifa: agregá los tramos (el primero desde 0).</p>}
            <div className="flex gap-1.5 pt-1">
                <button type="button" onClick={() => setTramos(ts => [...ts, { desde: ts.length ? '' : '0', precio: '' }])}
                    className="h-9 px-3 rounded-lg font-bold text-label bg-chip text-secondary active:scale-95 flex items-center gap-1"><LuPlus size={13} /> Tramo</button>
                <span className="flex-1" />
                {guardados.length > 0 && <button type="button" onClick={() => { setTramos(guardados); setEditando(false); }} className="h-9 px-3 rounded-lg font-bold text-label text-secondary">Cancelar</button>}
                <button type="button" onClick={guardar} disabled={guardando} className="h-9 px-4 rounded-lg font-black text-label bg-ink text-page active:scale-95 disabled:opacity-50">{guardando ? 'Guardando…' : 'Guardar'}</button>
            </div>
        </div>
    );
}
